import {Pipe, PipeTransform} from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable,forkJoin, interval } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppService } from '../commons/app.service';

@Pipe({
    name: 'translateDb',
    pure: true
})
export class TranslateDbPipe implements PipeTransform {

    languages:any = null;

    currentLanguage:string = 'en';

    // our translations, we need to inject them on every language change
    myTranslations:any = {};

    // global
    globalTranslations:any = null;

    constructor( private translator:TranslateService, private service:AppService ){
        
        this.currentLanguage = translator.getBrowserLang();
        console.log('Browser language is',this.currentLanguage)
        translator.setDefaultLang(translator.getBrowserLang())
      
        this.languages = translator.getLangs();

        translator.getTranslation(this.currentLanguage).subscribe( ret => {
            this.globalTranslations = ret;
        });

        translator.onLangChange.subscribe((event: LangChangeEvent) => {

            this.currentLanguage = event.lang;
            this.globalTranslations = event.translations;

            this.updateTranslations();

        });

    }

    updateTranslations ( hash:any = null ) {

        let final = this.globalTranslations;
        let these = this.myTranslations;

        if ( hash ) {
            these = { [hash]: this.myTranslations[hash] };
        }

        Object.keys(these).forEach(hash => {
            if ( these[hash] ) {
                Object.keys(these[hash]).forEach(k => {
                    if ( these[hash][k] && k == this.currentLanguage ) {
                        final[hash] = these[hash][k];
                    }
                });
            }
        });

        // console.log('setting',this.currentLanguage, final);
        this.translator.setTranslation ( this.currentLanguage, final );
    }

    parseValues ( value:any ) {
        let lut:any = {};
        let languages = value.split('|');
        if ( languages.length > 0 ) {
            languages.forEach( language => {
                let split = language.split(':');
                if ( split.length > 1 ) {
                    lut[split[0].trim()] = split[1].trim();
                } else {
                    this.languages.forEach( l => {
                        lut[l] = split[0];
                    });
                }
            });
        }
        return lut;
    }

    transform(value: any, args?: any) : Observable<string> {

        // test data
        // if ( value == 'Entry' ) { value = "ja:Japanese text here | en:English headline here | no:Norsktalende tekst"; }

        // hash code for our translation
        let hash = 'DB.LUT_' + this.getHash('' + value);

        // stuff my parsed values into the global lookup-table
        this.myTranslations[hash] = this.parseValues(value);

        // update this one's translation records
        this.updateTranslations(hash);

        return this.translator.stream( hash );

    }

    getHash( str:string ) {
        var hash = 0, i, chr;
        for (i = 0; i < str.length; i++) {
            chr   = str.charCodeAt(i);
            hash  = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return (hash + 2147483647) + 1;
    }

}